// Copyright (c) Frisbii GmbH. All rights reserved.
'use strict';

var ExternalSubscriptionDetailController = function ($scope, $routeParams, $http, ExternalSubscription, Contract, ProductInfo, $window) {
    $scope.selectedTab = "overview";

    var update = function () {
        $scope.externalSubscription = ExternalSubscription.get({ id: $routeParams.id }, function () {
            $scope.selectRevision($scope.externalSubscription.Revisions[$scope.externalSubscription.Revisions.length - 1]);
            
            if ($scope.externalSubscription.Events.length) {
                $scope.selectEvent($scope.externalSubscription.Events[$scope.externalSubscription.Events.length - 1]);
            }
            
            if ($scope.externalSubscription.Phases) {
                $scope.reversedPhases = $scope.externalSubscription.Phases.slice(0).reverse();
            }
        });
        $scope.contracts = Contract.query({ externalSubscriptionId: $routeParams.id });
    };

    update();
    $scope.productInfo = ProductInfo.get();

    $scope.refresh = function () {
        $http({
            method: "POST", url: "api/v1/externalSubscriptions/" + $routeParams.id + "/refresh",
            params: null,
            data: {},
            headers: { "Content-Type": "application/json" },
            cache: false
        }).then(function () {
            update();
        });
    };

    $scope.selectRevision = function (revision) {
        $scope.selectedRevision = revision;
        $scope.selectedRevisionData = JSON.stringify(JSON.parse(revision.Raw), null, 2);
    };

    $scope.selectEvent = function (event) {
        $scope.selectedEvent = event;
        $scope.selectedEventData = JSON.stringify(JSON.parse(event.Raw), null, 2);
    };

    $scope.back = function () {
        $window.history.back();
    };
};
ExternalSubscriptionDetailController.$inject = ['$scope', '$routeParams', '$http', 'ExternalSubscription', 'Contract', 'ProductInfo', '$window'];
